const STATUS_STYLES = {
  concept: 'bg-blue-100 text-blue-700',
  prototype: 'bg-purple-100 text-purple-700',
  pitched: 'bg-yellow-100 text-yellow-700',
  licensed: 'bg-green-100 text-green-700',
  archived: 'bg-gray-100 text-gray-500',
  sleeping: 'bg-teal-100 text-teal-700',
};

const STATUS_LABELS = {
  concept: 'Concept',
  prototype: 'Prototype',
  pitched: 'Pitched',
  licensed: 'Licensed',
  archived: 'Archived',
  sleeping: 'Sleeping',
};

export default function StatusBadge({ status }) {
  return (
    <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium ${STATUS_STYLES[status] || STATUS_STYLES.concept}`}>
      {STATUS_LABELS[status] || status}
    </span>
  );
}
